import React from 'react';
import { styled } from '@components-shared/src/stitches';
import {
  Card,
  Fade,
  InfoContainer,
  LeftContainer,
  Name,
  Rank,
  RightContainer,
  Top,
  UnclaimedTop,
} from './styles';

export const UnclaimedCard = ({ index }: { index: number }) => {
  return (
    <div>
      <Card unclaimed>
        <LeftContainer>
          <CustomTop>
            <Rank>{index}</Rank>
          </CustomTop>
          <div className="block h-14 w-14 rounded-bl-md bg-neutral200" />
        </LeftContainer>
        <RightContainer>
          <UnclaimedTop>
            <CustomName>Unclaimed</CustomName>
            <Fade position="end" />
          </UnclaimedTop>
          <InfoContainer />
        </RightContainer>
      </Card>
    </div>
  );
};

const CustomTop = styled(Top, {
  borderRight: '1px solid $neutral200',
});

const CustomName = styled(Name, {
  cursor: 'unset',
  maxWidth: 'unset',
});
